import { iconNames } from "./iconNames";
import { AddIcon } from "./icons/AddIcon";
import { ArrowIcon } from "./icons/ArrowIcon";
import { CalendarIcon } from "./icons/CalendarIcon";
import { ChatIcon } from "./icons/ChatIcon";
import { CheckIcon } from "./icons/CheckIcon";
import { ChevronIcon } from "./icons/ChevronIcon";
import { CloseIcon } from "./icons/CloseIcon";
import { CopyIcon } from "./icons/CopyIcon";
import { CrosshairIcon } from "./icons/CrosshairIcon";
import { DiagonalLineIcon } from "./icons/DiagonalLineIcon";
import { DotIcon } from "./icons/DotIcon";
import { GraphIcon } from "./icons/GraphIcon";
import { IndeterminateCheckIcon } from "./icons/IndeterminateCheckIcon";
import { InfoIcon } from "./icons/InfoIcon";
import { LockFilledIcon } from "./icons/LockFilledIcon";
import { LockIcon } from "./icons/LockIcon";
import { LockOpenIcon } from "./icons/LockOpenIcon";
import { LogOutIcon } from "./icons/LogOutIcon";
import { MapIcon } from "./icons/MapIcon";
import { MegaphoneIcon } from "./icons/MegaphoneIcon";
import { MoonIcon } from "./icons/MoonIcon";
import { PencilIcon } from "./icons/PencilIcon";
import { RadiationIcon } from "./icons/RadiationIcon";
import { SearchIcon } from "./icons/SearchIcon";
import { SettingsIcon } from "./icons/SettingsIcon";
import { ShoppingCartIcon } from "./icons/ShoppingCartIcon";
import { SunIcon } from "./icons/SunIcon";
import { TrashIcon } from "./icons/TrashIcon";
import { TrendUpIcon } from "./icons/TrendUpIcon";
import { TruckIcon } from "./icons/TruckIcon";
import { WandIcon } from "./icons/WandIcon";
import { WarningIcon } from "./icons/WarningIcon";
import { WrenchIcon } from "./icons/WrenchIcon";

/**
 * DAS-4283: Add aria-labels to icons to improve accessibility
 */

export interface IconProps {
  /**
   * The name of the icon to render.
   *
   * This should match one of the predefined icon names.
   */
  name?: (typeof iconNames)[number];
}

export function Icon({ name }: IconProps) {
  switch (name) {
    case "copy":
      return <CopyIcon />;
    case "close":
      return <CloseIcon />;
    case "crosshair":
      return <CrosshairIcon />;
    case "graph":
      return <GraphIcon />;
    case "calendar":
      return <CalendarIcon />;
    case "search":
      return <SearchIcon />;
    case "check":
      return <CheckIcon />;
    case "sun":
      return <SunIcon />;
    case "settings":
      return <SettingsIcon />;
    case "log-out":
      return <LogOutIcon />;
    case "moon":
      return <MoonIcon />;
    case "chevron-up":
      return <ChevronIcon direction="up" />;
    case "chevron-down":
      return <ChevronIcon direction="down" />;
    case "chevron-left":
      return <ChevronIcon direction="left" />;
    case "chevron-right":
      return <ChevronIcon direction="right" />;
    case "arrow-right":
      return <ArrowIcon />;
    case "diagonal-line":
      return <DiagonalLineIcon />;
    case "dot":
      return <DotIcon />;
    case "shopping-cart":
      return <ShoppingCartIcon />;
    case "add":
      return <AddIcon />;
    case "indeterminate-check":
      return <IndeterminateCheckIcon />;
    case "info":
      return <InfoIcon />;
    case "lock":
      return <LockIcon />;
    case "lock-filled":
      return <LockFilledIcon />;
    case "lock-open":
      return <LockOpenIcon />;
    case "megaphone":
      return <MegaphoneIcon />;
    case "warning":
      return <WarningIcon />;
    case "wand":
      return <WandIcon />;
    case "radiation":
      return <RadiationIcon />;
    case "trash":
      return <TrashIcon />;
    case "wrench":
      return <WrenchIcon />;
    case "pencil":
      return <PencilIcon />;
    case "map":
      return <MapIcon />;
    case "truck":
      return <TruckIcon />;
    case "trend-up":
      return <TrendUpIcon />;
    case "chat":
      return <ChatIcon />;

    default:
      throw new Error(`Icon "${name}" does not exist.`);
  }
}
